<template>
    <div v-if="approved">
        <div class="card">
            <div class="card-body">
                <p v-for="line in description" :key="line">
                    {{ line }}
                </p>
                <p>&mdash; Constant Cookbook</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RecipeDescription",
    props: ["recipe"],
    data() {
        return {
            description: this.recipe.description.split("\n"),
            approved: this.recipe.desc_approved,
        };
    },
};
</script>
<style scoped></style>
